/** Marker2D registration: the parser. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseMarker2D } from './parser';
const marker2DRegistration = {
    typeName: 'Marker2D',
    parser: parseMarker2D,
};
nodeRegistry.register(marker2DRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map